// removed by extract-text-webpack-plugin
module.exports = {"table":"table__1AMjO","desc":"desc__3N6NI","btn-blue-solid":"btn-blue-solid__2l92S"};


//////////////////
// WEBPACK FOOTER
// ./styles/sip-calculator.scss
// module id = 1273
// module chunks = 68